'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var history = arguments.length <= 0 || arguments[0] === undefined ? _reactRouter.browserHistory : arguments[0];

  return _react2.default.createElement(
    _reactRouter.Router,
    { history: history, onUpdate: function onUpdate() {
        return window.scrollTo(0, 0);
      } },
    _react2.default.createElement(
      _reactRouter.Route,
      { path: '/', component: _App2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Home2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'category/:category', component: _Category2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'search/:keyword', component: _Search2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'section/:section', component: _Section2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'tag/:tagId', component: _Tag2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'topic/:topicId', component: _Topic2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'timeline', component: _Timeline2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'q/:questionnaireId(/:resultIdForOg)', component: _Questionnaire2.default })
    )
  );
};

var _App = require('../containers/App');

var _App2 = _interopRequireDefault(_App);

var _Category = require('../containers/Category');

var _Category2 = _interopRequireDefault(_Category);

var _Home = require('../containers/Home');

var _Home2 = _interopRequireDefault(_Home);

var _Questionnaire = require('../containers/Questionnaire');

var _Questionnaire2 = _interopRequireDefault(_Questionnaire);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Search = require('../containers/Search');

var _Search2 = _interopRequireDefault(_Search);

var _Section = require('../containers/Section');

var _Section2 = _interopRequireDefault(_Section);

var _Tag = require('../containers/Tag');

var _Tag2 = _interopRequireDefault(_Tag);

var _Timeline = require('../containers/Timeline');

var _Timeline2 = _interopRequireDefault(_Timeline);

var _Topic = require('../containers/Topic');

var _Topic2 = _interopRequireDefault(_Topic);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


/*****************
 ** WEBPACK FOOTER
 ** ./src/routes/index.js
 ** module id = 838
 ** module chunks = 0
 **/